import { Widget as WidgetType } from './utils/utils';
import React from 'react';
import { DisplayType } from './utils/utils';
import Drag from 'app/shared/icons/drag';
import Edit from 'app/shared/icons/widget-edit-icon';
import Delete from 'app/shared/icons/widget-delete-icon';
type WidgetProps = {
  widget: WidgetType;
  itemIndex: number;
  onRemove: (i: number) => void;
  onEdit: () => void;
  theme: string;
  children: React.ReactNode;
};

export const Widget: React.FC<WidgetProps> = ({ widget, onRemove, onEdit, children, itemIndex, theme }) => {
  return (
    <div style={{ height: '98%', display: 'flex', flexDirection: 'column' }}>
      <div className="widget-header">
        {widget.definition && (
          <>
            <div className="widget-title">
              <div className="widget-name">{widget.definition.title}</div>
              <div className="v-type">{DisplayType.find(e => e.key === widget.definition.type)?.name}</div>
            </div>
            <div className="widget-toolbar">
              <span title="drag">
                <Drag />
              </span>
              <span title="edit" onClick={() => onEdit()}>
                <Edit />
              </span>
              <span title="remove" onClick={() => onRemove(itemIndex)}>
                <Delete />
              </span>
            </div>
          </>
        )}
      </div>
      <div className="wc-container" style={theme === 'light' ? { background: 'white' } : {}}>
        {children}
      </div>
    </div>
  );
};
